export default "__VITE_ASSET__BYLXGzBj__"